import { IFormRegister } from 'routes/Main/type';
import { Box, Typography } from '@mui/material';

import Form from 'components/Form';
import RowContainer from '../../components/RowContainer';
import RowContent from '../../components/RowContent';

interface Props extends IFormRegister {
  disabled?: boolean;
}

const Signature = (props: Props) => {
  const { disabled, register } = props;

  const labels = [
    { title: 'Tên bệnh nhân', variable: 'recorde_person_name' },
    {
      title: 'Chữ ký bệnh nhân',
      variable: 'recorde_person_sig',
    },
    { title: 'Ngày', variable: 'recorde_date' },
  ];

  const labels2 = [
    { title: 'Tên bác sĩ', variable: 'register_person_name' },
    { title: 'Chữ ký bác sĩ', variable: 'register_person_sig' },
    { title: 'Ngày', variable: 'register_date' },
  ];

  return (
    <>
      <RowContainer xs={12} mb={3}>
        {labels.map(({ title, variable }, _) => (
          <>
            {variable === 'recorde_date' ? (
              <RowContent
                key={variable}
                title={title}
                titleRatio={0.5}
                childrenRatio={2}
              >
                <Form.MuiTextField
                  type="date"
                  disabled={disabled}
                  {...register(`${variable}`)}
                />
              </RowContent>
            ) : (
              <RowContent
                key={variable}
                title={title}
                titleRatio={1.3}
                childrenRatio={2}
              >
                <Form.MuiTextField
                  disabled={disabled}
                  {...register(`${variable}`)}
                />
              </RowContent>
            )}
          </>
        ))}
        <Box
          sx={{
            width: '95.5%',
            margin: '20px auto 10px auto',
          }}
        >
          <Typography
            sx={{
              fontWeight: '400',
              fontSize: '15px',
              lineHeight: '24px',
              whiteSpace: 'pre-wrap',
            }}
          >
            Tôi khẳng định bệnh nhân đang đưa ra quyết định trong điều kiện tỉnh
            táo và đơn này là mong muốn thể hiện của bệnh nhân. Bản sao của mẫu
            đơn này có trong hồ sơ y tế của bệnh nhân.
          </Typography>
        </Box>

        {labels2.map(({ title, variable }, _) => (
          <>
            {variable === 'register_date' ? (
              <RowContent
                key={variable}
                title={title}
                titleRatio={0.5}
                childrenRatio={2}
              >
                <Form.MuiTextField
                  type="date"
                  disabled={disabled}
                  {...register(`${variable}`)}
                />
              </RowContent>
            ) : (
              <RowContent
                key={variable}
                title={title}
                titleRatio={1.3}
                childrenRatio={2}
              >
                <Form.MuiTextField
                  disabled={disabled}
                  {...register(`${variable}`)}
                />
              </RowContent>
            )}
          </>
        ))}
      </RowContainer>
    </>
  );
};

export default Signature;
